import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

function Footer() {
  return (
    <footer className="bg-dark text-light py-4">
      <Container>
        <Row>
          <Col md={4} className="text-center">
            <a className="text-light" href="terminos_condiciones.php">Terminos y condiciones</a><br />
          </Col>
          <Col md={4} className="text-center">
            <a className="text-light" href="politica_privacidad.php">Politica de privacidad</a><br />
          </Col>
          <Col md={4} className="text-center">
            <a className="text-light" href="politica_cookies.php">Politica de cookies</a>
          </Col>
        </Row>
        <p className="text-center">Ashcastillo Studios {new Date().getFullYear()} - Todos los derechos reservados</p>
      </Container>
    </footer>
  );
}

export default Footer;